enum AudioActionSelectionLabels {
    Edit = 'Edit Details',
    Preview = 'Preview',
}

export default AudioActionSelectionLabels;
